import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { NotificationManager } from "react-notifications";
import { reduxForm, Field, reset, change } from "redux-form";
import { searchPatientFood, resetField } from "../../../store/actions";
import { FormField } from "../../../sharedComponents/formField";
import { required } from "../../../constants/formValidators";

const SearchPatientFood = ({
	handleSubmit,
	resetForm,
	recipeFoodSearchKeyword,
	footer = null,
	searchPatientFood,
	resetField,
}) => {
	useEffect(() => {
		if (recipeFoodSearchKeyword) {
			change("SearchIngredientsForm", "search", recipeFoodSearchKeyword.search);
			change("SearchIngredientsForm", "hier1", recipeFoodSearchKeyword.hier1);
			change("SearchIngredientsForm", "useful", recipeFoodSearchKeyword.useful);
		} else {
			resetForm("SearchPatientFood");
		}
	}, [recipeFoodSearchKeyword, resetForm]);

	const [submitting, setSubmitting] = useState(false);

	const handleSearch = (values) => {
		setSubmitting(true);
		const successHandler = (res) => {
			res.json().then((data) => {
				if (data && data.results && data.results.length) {
					resetField("FoodDatabase.foodApprovalList", data);
				}
				if (data && data.results && !data.results.length) {
					NotificationManager.error("No items found!", "", 5000);
				}
			});
		};
		if (values && values.search) {
			resetField("AddRecipe.recipeFoodSearchKeyword", values);
			searchPatientFood(`${values.search}&limit=20`, successHandler);
		} else {
			NotificationManager.error("Enter search term!", "", 5000);
		}
	};
	const clearForm = () => {
		resetForm("SearchPatientFood");
	};

	return (
		<React.Fragment>
			<form className="row" onSubmit={handleSubmit(handleSearch)}>
				<div className="col-12">
					<Field
						name="search"
						label="Search Term"
						placeholder="Keywords"
						type="text"
						component={FormField}
						validate={[required]}
						onChange={() => setSubmitting(false)}
					/>
				</div>
				<div className="col-12">
					<button type="submit" disabled={submitting} className="w-100 btn btn-primary-dark mt-4 text-uppercase">
						search now
					</button>
				</div>
				<div className="col-12">
					<button type="button" onClick={clearForm} className="w-100 btn btn-primary btn-ghost mt-4 pl-0 pr-0">
						Clear
					</button>
				</div>
			</form>
			{footer}
		</React.Fragment>
	);
};

const mapStateToProps = (state) => {
	return {
		recipeFoodSearchKeyword: get(state, "AddRecipe.recipeFoodSearchKeyword", null),
	};
};

const mapDispatchToProps = {
	searchPatientFood,
	resetForm: reset,
	resetField,
	change,
};

export default reduxForm({
	form: "SearchPatientFood",
	enableReinitialize: true,
})(connect(mapStateToProps, mapDispatchToProps)(SearchPatientFood));
